export default __webpack_public_path__ + "static/media/inital-scratch-card-white.dda9b84b.gif";